import { CONFIGS } from '../../rocket-configs';

import { useSetupGuide } from '@/features/setup-guide/hook';
import { ROCKET_STEPS_COMPLETION_MODEL_IDS } from '../../rocket-configs';
import { RocketPlainHeader } from '../plain';

interface AdventuresHeaderProps {
  onClose: () => void;
}

export function AdventuresHeader({ onClose }: AdventuresHeaderProps) {
  const { setupGuideQuery } = useSetupGuide();
  const { data: setupGuide } = setupGuideQuery;

  const completedAdventures = ROCKET_STEPS_COMPLETION_MODEL_IDS.filter((key) => {
    return setupGuide?.setup_guide?.[key] != null;
  }).length;

  const areAllAdventuresCompleted = completedAdventures === CONFIGS.length;

  const title = areAllAdventuresCompleted ? 'Trial Complete' : 'Trial Progress';
  const label = areAllAdventuresCompleted
    ? 'Adventures complete!'
    : `${completedAdventures} / ${CONFIGS.length} adventures completed`;

  return <RocketPlainHeader title={title} label={label} onClose={onClose} />;
}
